import React from 'react';
import { Stack, TextInput, Textarea, Button, Title, Group, Switch, Select, Tooltip, Text } from '@mantine/core';
import { DateInput } from '@mantine/dates';
import { useCampaign } from '../../context/CampaignContext';
import { useSalon } from '../../context/SalonContext';
import moment from 'moment-timezone';

function CampaignSetupStep({ onNext }) {
  const { 
    name, 
    setName, 
    description, 
    setDescription, 
    errors,
    isScheduled,
    setIsScheduled,
    scheduledDate,
    setScheduledDate,
    scheduledTime,
    setScheduledTime
  } = useCampaign();
  
  const { businessInfo } = useSalon();

  // Generate time slots in 30-minute intervals
  const timeSlots = React.useMemo(() => {
    const slots = [];
    for (let hour = 8; hour < 21; hour++) {
      for (let minute of [0, 30]) {
        const time = moment().hour(hour).minute(minute).format('h:mm A');
        slots.push({ value: time, label: time });
      }
    }
    return slots;
  }, []);

  // Validate scheduled time
  const validateScheduledTime = () => {
    if (!isScheduled) return true;
    
    const now = moment();
    const scheduled = moment.tz(scheduledDate, businessInfo.timezone)
      .hour(moment(scheduledTime, 'h:mm A').hour())
      .minute(moment(scheduledTime, 'h:mm A').minute());
    
    return scheduled.isAfter(now);
  };

  const handleNext = () => {
    if (isScheduled && !validateScheduledTime()) {
      return;
    }
    onNext();
  };

  return (
    <Stack gap="md">
      <Title order={3}>Campaign Setup</Title>
      <TextInput
        label="Campaign Name"
        value={name}
        onChange={e => setName(e.target.value)}
        error={errors.name}
        required
      />
      <Textarea
        label="Description"
        value={description}
        onChange={e => setDescription(e.target.value)}
        error={errors.description}
        minRows={3}
        maxRows={6}
        required
        description="10-256 characters"
      />
      <Switch
        label="Schedule for later"
        checked={isScheduled}
        onChange={(event) => setIsScheduled(event.currentTarget.checked)}
      />
      {isScheduled && (
        <Stack gap="xs">
          <DateInput
            label="Date"
            value={scheduledDate}
            onChange={setScheduledDate}
            minDate={new Date()}
            maxDate={moment().add(1, 'years').toDate()}
            required
          />
          <Tooltip label="Messages should be sent during business hours (8 AM - 9 PM)">
            <Select
              label="Time"
              value={scheduledTime}
              onChange={setScheduledTime}
              data={timeSlots}
              required
            />
          </Tooltip>
          {!validateScheduledTime() && (
            <Text size="sm" c="red">
              Scheduled time must be in the future
            </Text>
          )}
        </Stack>
      )}
      <Group justify="flex-end">
        <Button onClick={handleNext}>Next</Button>
      </Group>
    </Stack>
  );
}

export default CampaignSetupStep; 